module.exports = __webpack_public_path__ + "static/media/1 21 gatt.83e9b513.mp3";